<p-panel>
    <app-reactive-form-builder #builderRef [form]="form.formFields"
        [serverUrl]="form.env.serverUrl" [id]="getRegisterId().toString()"
        [request]="getType() === 1 ? tratamientosApi.tratamientosPUT : tratamientosApi.tratamientosPOST"
        [getRequest]="tratamientosApi.tratamientosGET" [previousData]="initialPreviousData"
        [dropdownLoadTrigger]="dropdownLoadTrigger"
        (stableValueChanges)="stableValueChanges($event)" (goBack)="goBack()">
    </app-reactive-form-builder>
</p-panel>
